module.exports = __webpack_public_path__ + "static/media/logoImage.4eddf95f.png";